module.exports = __webpack_public_path__ + "img/android2icon2.2f61a7b1.png";